import React from "react";
import { findResultsState } from "react-instantsearch-dom/server";
import algoliaClient from "~/components/search/utils/algoliaClient";
import getIndexName from "~/components/search/utils/getIndexName";
import GovernmentsPage from "~/src/components/home/pages/GovernmentsPage";

interface IGovernmentsProps {
  resultsState: any;
  widgetsCollector: any;
}

const Governments = (props: IGovernmentsProps) => {
  return <GovernmentsPage {...props} />;
};

Governments.getInitialProps = async () => {
  try {
    const resultsState: any = await findResultsState(GovernmentsPage, {
      searchClient: algoliaClient,
      searchState: {},
      indexName: getIndexName("governments"),
    });

    return {
      resultsState,
    };
  } catch (e) {
    return {};
  }
};

export default Governments;
